<template>
  <v-dialog :value="showModal" persistent max-width="500" overlay-opacity="0.8">
    <v-card class="text-center pa-6">
      <v-card-text>
        <v-icon size="80" color="error" class="mb-4">mdi-server-off</v-icon>

        <h2 class="text-h5 font-weight-medium mb-3">
          {{ $t('Server Temporarily Unavailable') }}
        </h2>

        <p class="text-body-1 grey--text text--darken-1 mb-4">
          {{
            $t(
              'The service is unavailable right now. Please wait a bit and refresh the page to try again.'
            )
          }}
        </p>
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn color="primary" large @click="handleRetry">
          <v-icon left>mdi-refresh</v-icon>
          {{ $t('Refresh Page') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ServerErrorModal',

  data() {
    return {}
  },

  computed: {
    ...mapState({
      showModal: 'showServerErrorModal',
    }),
  },

  methods: {
    handleRetry() {
      window.location.reload()
    },
  },
}
</script>

<style scoped>
.v-dialog {
  z-index: 9999;
}

.v-card {
  border-radius: 12px;
}

.v-icon {
  opacity: 0.8;
}
</style>
